import { BaseEntity } from "../../../models/concrete/BaseEntity.mjs";
export class WishlistItem extends BaseEntity {
  category;
  imageId;
  imageIds;
  code;
  name;
  price;
  oldPrice;
  quantity;
  unit;
  countStep;
  shortDescription;
  rating;
  weight;
  height;
  depth;
  width;
  slug;
  url;
  isHit;
  isExclusive;
  isPromo;
  promoName;
  isSpecial;
  isNew;
  countInPack;
  allowOutOfStock;
  hasModifications;
  productSetImageDots;
  options;
  isProductSet;
  isNotAvailable;
  hasOptions;
  modificationsCount;
  productSetParents;
  files;
  optionGroupsCount;
  reviewsCount;
  reviewsRating;
  productSetChildrenCount;
  characteristics;
  shortCharacteristics;
  additionalCategories;
  characteristicGroup;
  characteristicGroupId;
  bonusValue;
  totalBonusValue;
  isBonusesOutcoming;
  exchangeUpdatedAt;
  createdAt;
  updatedAt;
  constructor(data) {
    super(data);
    this.category = {
      id: data?.category?.id,
      name: data?.category?.name
    };
    this.imageId = data.image_id;
    this.imageIds = data.images_ids;
    this.code = data.code;
    this.name = data.name;
    this.price = data.price;
    this.oldPrice = data.price_old;
    this.quantity = data.quantity;
    this.unit = data.unit;
    this.countStep = data.count_step;
    this.shortDescription = data.short_description;
    this.rating = data.rating;
    this.weight = data.weight;
    this.height = data.height;
    this.depth = data.depth;
    this.width = data.width;
    this.slug = data.slug;
    this.url = data.url;
    this.isHit = data.is_hit;
    this.isExclusive = data.is_exclusive;
    this.isPromo = data.is_promo;
    this.promoName = data.promo_name;
    this.isSpecial = data.is_special;
    this.isNew = data.is_new;
    this.countInPack = data.count_in_pack;
    this.allowOutOfStock = data.allow_out_of_stock;
    this.hasModifications = data.has_modifications;
    this.productSetImageDots = data.product_set_image_dots;
    this.options = data.options;
    this.isProductSet = data.is_product_set;
    this.isNotAvailable = data.is_not_available;
    this.hasOptions = data.has_options;
    this.modificationsCount = data.modifications_count;
    this.productSetParents = data.productSetParents;
    this.files = data.files;
    this.optionGroupsCount = data.option_groups_count;
    this.reviewsCount = data.reviews_count;
    this.reviewsRating = data.reviews_rating;
    this.productSetChildrenCount = data.product_set_children_count;
    this.shortCharacteristics = data?.short_characteristics?.map((c) => ({
      id: c.id,
      name: c.name,
      slug: c.slug,
      values: c?.values.map((v) => ({
        id: v.id,
        slug: v.slug,
        value: v.value,
        imageId: v.image_id
      })),
      help: c.help,
      unit: c.unit,
      showInFilter: c.show_in_filter,
      nameForFilter: c.name_for_filter,
      nameForProduct: c.name_for_product,
      nameForProductCard: c.name_for_product_card,
      showInProduct: c.show_in_product,
      showInProductCard: c.show_in_product_card,
      hideNameOnProduct: c.hide_name_on_product,
      hideNameOnProductCard: c.hide_name_on_product_card,
      filterTemplate: c.filter_template,
      viewTemplate: c.view_template,
      filterType: c.type
    }));
    this.additionalCategories = data.additionalCategories;
    this.characteristicGroup = data.characteristicGroup;
    this.characteristicGroupId = data.characteristic_group_id;
    this.bonusValue = data.bonus_value;
    this.totalBonusValue = data.bonus_value_total;
    this.isBonusesOutcoming = data.is_bonuses_outcoming;
    this.createdAt = data.created_at;
    this.updatedAt = data.updated_at;
    this.exchangeUpdatedAt = data.exchange_updated_at;
    this.characteristics = data.characteristics?.map((c) => ({
      name: c.name,
      characteristics: c.characteristics?.map((c2) => ({
        id: c2.id,
        name: c2.name,
        slug: c2.slug,
        values: c2?.values.map((v) => ({
          id: v.id,
          slug: v.slug,
          value: v.value,
          imageId: v.image_id,
          sort: v.sort
        })),
        help: c2.help,
        unit: c2.unit,
        showInFilter: c2.show_in_filter,
        nameForFilter: c2.name_for_filter,
        nameForProduct: c2.name_for_product,
        nameForProductCard: c2.name_for_product_card,
        showInProduct: c2.show_in_product,
        showInProductCard: c2.show_in_product_card,
        hideNameOnProduct: c2.hide_name_on_product,
        hideNameOnProductCard: c2.hide_name_on_product_card,
        filterTemplate: c2.filter_template,
        viewTemplate: c2.view_template,
        filterType: c2.type,
        sort: c2.sort
      }))
    }));
  }
  toJSON() {
    return { ...this };
  }
}
